export const clientActionTypes = {
    SET_CURRENT_CLIENT: 'SET_CURRENT_CLIENT',
    SET_CURRENT_CLIENT_VALIDATED: 'SET_CURRENT_CLIENT_VALIDATED',
    SET_CLIENTS: 'SET_CLIENTS',
};